import { gql } from "lib/apolloClient";
import { subjectStandardFragment, standardSetFragment } from "./Fragments";

export const getOrganizationSubjectsGradesAndTagsQuery = gql`
  query getOrganizationSubjectsGradesAndTags(
    $orgId: ID!
    $curriculumProgramId: ID!
    $genericTagsFilter: GenericTagsFilter
  ) {
    node(id: $orgId, type: ORGANIZATION) {
      ... on Organization {
        id
        subjects(
          filters: {
            curriculumProgramIds: [$curriculumProgramId]
            archivalState: ACTIVE
          }
        ) {
          id
          name
        }
        grades(filters: { curriculumProgramIds: [$curriculumProgramId] }) {
          id
          name
        }
        genericTagsV2(filters: $genericTagsFilter) {
          id
          label
        }
      }
    }
  }
`;

export const getCourseStandardSetsQuery = gql`
  query getCourseStandardSets(
    $id: ID!
    $isPYPCurriculum: Boolean! = false
    $subjects: [ID!]
    $orderByDirection: OrderByDirectionEnum
  ) {
    node(id: $id, type: LEARNING_COURSE) {
      ... on LearningCourse {
        id
        standardsWrapper(
          filters: { subjects: $subjects }
          orderByDirection: $orderByDirection
        ) @skip(if: $isPYPCurriculum) {
          standardsEdge {
            standardSet {
              ...standardSetFragment
            }
            standards {
              id
            }
          }
        }

        benchmarksWrapper(
          filters: { subjects: $subjects }
          orderByDirection: $orderByDirection
        ) @include(if: $isPYPCurriculum) {
          standardsEdge {
            standardSet {
              ...standardSetFragment
            }
            standards {
              id
            }
          }
        }
      }
    }
  }
  ${standardSetFragment}
`;

export const getCurriculumStandardSetsQuery = gql`
  query getCurriculumStandardSets(
    $id: ID!
    $type: ENTITY_TYPE_ENUM!
    $subjectIds: [ID!]
    $setId: ID!
    $orderBy: OrderByEnum
    $orderByDirection: OrderByDirectionEnum
  ) {
    node(id: $id, type: $type) {
      id
      ... on UBDCurriculumProgram {
        plannerElementNodeSets(
          filters: {
            status: [PUBLISHED, ARCHIVED, PARTIALLY_PUBLISHED]
            subjects: $subjectIds
            plannerElementIds: [$setId]
          }
          orderBy: $orderBy
          orderByDirection: $orderByDirection
        ) {
          ...subjectStandardFragment
        }
      }

      ... on IbMypCurriculumProgram {
        plannerElementNodeSets(
          filters: {
            status: [PUBLISHED, ARCHIVED, PARTIALLY_PUBLISHED]
            subjects: $subjectIds
            plannerElementIds: [$setId]
          }
          orderBy: $orderBy
          orderByDirection: $orderByDirection
        ) {
          ...subjectStandardFragment
        }
      }

      ... on IbPypCurriculumProgram {
        plannerElementNodeSets(
          filters: {
            status: [PUBLISHED, ARCHIVED, PARTIALLY_PUBLISHED]
            subjects: $subjectIds
            plannerElementIds: [$setId]
          }
          orderBy: $orderBy
          orderByDirection: $orderByDirection
        ) {
          ...subjectStandardFragment
        }
      }

      ... on IbDpCurriculumProgram {
        plannerElementNodeSets(
          filters: {
            status: [PUBLISHED, ARCHIVED, PARTIALLY_PUBLISHED]
            subjects: $subjectIds
            plannerElementIds: [$setId]
          }
          orderBy: $orderBy
          orderByDirection: $orderByDirection
        ) {
          ...subjectStandardFragment
        }
      }
    }
  }
  ${subjectStandardFragment}
`;

export const getSubjectStandardSetDetailsQuery = gql`
  query getSubjectStandardSetDetails($id: ID!, $learningCourseIds: [ID!]) {
    node(id: $id, type: SUBJECT) {
      ... on Subject {
        id
        plannerElementNodeSet {
          id
          title
          isArchived
          subject {
            id
            name
            isArchived
          }
          plannerElementNodeSetWrapperV2 {
            ... on PlannerElementNodeSetWrapper {
              publishedData {
                totalCount
              }
            }
            ... on PlannerBenchmarkSetWrapper {
              publishedData {
                totalCount
              }
            }
          }
          courseStandards(ids: $learningCourseIds) {
            id
          }
          courseBenchmarkStandards(ids: $learningCourseIds) {
            id
          }
        }
      }
    }
  }
`;
